import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";

import { cn } from "@/shared/lib";

import type { ConnectionState } from "./ConnectionState";
import { useConnectionState } from "./useConnectionState";

const LABELS = {
  connected: msg`Live updates are on`,
  connecting: msg`Connecting to live updates`,
  disconnected: msg`Live updates are off`,
} as const;

const DOT_CLASSES: Record<ConnectionState, string> = {
  connected: "bg-good",
  connecting: cn("bg-warn", "animate-pulse"),
  disconnected: "bg-subtle",
};

type ConnectionIndicatorProps = {
  className?: string;
};

// Ненавязчивая точка для шапки: видно, почему прогресс может не двигаться.
export const ConnectionIndicator = ({ className }: ConnectionIndicatorProps) => {
  const { _ } = useLingui();
  const state = useConnectionState();
  const label = _(LABELS[state]);
  return (
    <span
      role="status"
      data-state={state}
      title={label}
      className={cn("inline-flex size-4 items-center justify-center", className)}
    >
      <span aria-hidden="true" className={cn("size-2 rounded-full", DOT_CLASSES[state])} />
      <span className="sr-only">{label}</span>
    </span>
  );
};
